export enum ConnectorStatusEnum {
  Available = 'Available',
  Preparing = 'Preparing',
  Charging = 'Charging',
  SuspendedEVSE = 'SuspendedEVSE',
  SuspendedEV = 'SuspendedEV',
  Finishing = 'ChargingFinished',
  Reserved = 'Reserved',
  Unavailable = 'Unavailable',
  Faulted = 'Faulted',
  Offline = 'Offline',
  Unexpected = 'Unexpected',
}

export enum StartChargeTypeEnum {
  APP = 'ChargeByScanning',
  CARD = 'CardCharge',
  VIN = 'VINCharge',
  AUTOCHARGE = 'ChargeAnyTime',
}

export type OperationViewStatus =
  | 'Available'
  | 'Charging'
  | 'Hogging'
  | 'Faulted'
  | 'Unavailable'
  | 'Offline'
  | 'Reserved';

export interface GunInfo {
  anyAlarm: boolean;
  connectorStatus: keyof typeof ConnectorStatusEnum;
  currentMode: string;
  gunId: number;
  gunTypeId: number;
  gunName: string;
  operationViewStatus: OperationViewStatus;
  parkingLotName: string;
  pileId: number;
  pileTypeId: number;
  pileName: string;
  ratingPower: number;
  socketType: string; // J1772, Mennekes, CCS1, CCS2, CHAdeMO
  transactionalData?: {
    billNo: string;
    current: number; // A
    duration: number; // second
    energyOffered: number; // kWh
    memberId: number;
    memberName: string;
    soc: number; // %; only meaningful when currentMode is DC
    startChargeType: keyof typeof StartChargeTypeEnum; // APP, CARD, VIN
    voltage: number; // V
    ratingPower: number; // kW
  };
}
